import { createReducer } from 'typesafe-actions';

import { IState } from '@/store/types/search.types';
import { IProfile, IProfileKYCsState } from '@/store/models/profile.model';
import { IProfileState } from '@/store/types/profile.types';
import { TProfileKycAction, ProfileKycActionTypes } from '@/features/kyc/store/types/profile-kyc.types';

const initialState: IProfileState = {
  profiles: {
    state: [],
  },
};

export const profileKycReducer = (handleAsyncProfileReducer) =>
  createReducer<IProfileState, TProfileKycAction>(initialState)
    /**
     * Get KYC payins reducers
     */
    .handleType(ProfileKycActionTypes.GET_KYC_PROFILE_PAYINS, (state, action) =>
      handleAsyncProfileReducer(state, action.userId, { kyc: { payins: {} } }),
    )

    .handleType(ProfileKycActionTypes.GET_KYC_PROFILE_PAYINS_FAIL, (state, action) =>
      handleAsyncProfileReducer(state, action.userId, { kyc: { payins: {} } }, { error: action.error }),
    )

    .handleType(ProfileKycActionTypes.GET_KYC_PROFILE_PAYINS_SUCCESS, (state, action) =>
      handleAsyncProfileReducer(
        state,
        action.userId,
        { kyc: { payins: {} } },
        { state: action.payins, error: undefined },
      ),
    )

    /**
     * Get KYC documents reducers
     */
    .handleType(ProfileKycActionTypes.GET_KYC_DOCUMENTS, (state, action) =>
      handleAsyncProfileReducer(state, action.userId, { kyc: {} }),
    )

    .handleType(ProfileKycActionTypes.GET_KYC_DOCUMENTS_FAIL, (state, action) =>
      handleAsyncProfileReducer(state, action.userId, { kyc: {} }, { error: action.error }),
    )

    .handleType(ProfileKycActionTypes.GET_KYC_DOCUMENTS_SUCCESS, (state, action) =>
      handleAsyncProfileReducer(
        state,
        action.userId,
        { kyc: {} },
        {
          state: {
            documents: { state: action.documents.map((document) => ({ document })) },
          },
        },
      ),
    )

    /**
     * Get KYC document preview reducers
     */
    .handleType(ProfileKycActionTypes.GET_KYC_DOCUMENT_PREVIEW, (state, action) => {
      const profiles = state.profiles.state?.map((profile) => {
        if (profile.state?.user.state?.userId === action.userId) {
          return {
            ...profile,
            state: {
              ...profile.state,
              profileKYCs: {
                ...profile.state.profileKYCs,
                state: {
                  ...profile.state?.profileKYCs?.state,
                  documents: {
                    ...profile.state?.profileKYCs?.state?.documents,
                    state: profile.state?.profileKYCs?.state?.documents?.state?.map((kycDocument) => {
                      if (kycDocument.document.documentId === action.document.documentId)
                        return {
                          ...kycDocument,
                          preview: {
                            ...kycDocument.preview,
                            isLoading: true,
                          },
                        };
                      return kycDocument;
                    }),
                  },
                },
              },
            },
          };
        }
        return profile;
      });

      return {
        ...state,
        profiles: {
          state: profiles,
        },
      };
    })

    .handleType(ProfileKycActionTypes.GET_KYC_DOCUMENT_PREVIEW_FAIL, (state, action) => {
      const profiles = state.profiles.state?.map((profile) => {
        if (profile.state?.user.state?.userId === action.document.userId) {
          return {
            ...profile,
            state: {
              ...profile.state,
              profileKYCs: {
                ...profile.state.profileKYCs,
                state: {
                  ...profile.state?.profileKYCs?.state,
                  documents: {
                    ...profile.state?.profileKYCs?.state?.documents,
                    state: profile.state?.profileKYCs?.state?.documents?.state?.map((kycDocument) => {
                      if (kycDocument.document.documentId === action.document.documentId)
                        return {
                          ...kycDocument,
                          preview: {
                            ...kycDocument.preview,
                            isLoading: false,
                            error: action.error,
                          },
                        };
                      return kycDocument;
                    }),
                  },
                },
              },
            },
          };
        }
        return profile;
      });

      return {
        ...state,
        profiles: {
          state: profiles,
        },
      };
    })

    .handleType(ProfileKycActionTypes.GET_KYC_DOCUMENT_PREVIEW_SUCCESS, (state, action) => {
      const profiles = state.profiles.state?.map((profile) => {
        if (profile.state?.user.state?.userId === action.document.userId) {
          return {
            ...profile,
            state: {
              ...profile.state,
              profileKYCs: {
                ...profile.state.profileKYCs,
                state: {
                  ...profile.state?.profileKYCs?.state,
                  documents: {
                    ...profile.state?.profileKYCs?.state?.documents,
                    state: profile.state?.profileKYCs?.state?.documents?.state?.map((kycDocument) => {
                      if (kycDocument.document.documentId === action.document.documentId)
                        return {
                          ...kycDocument,
                          preview: {
                            state: action.preview,
                            isLoading: false,
                            error: undefined,
                          },
                        };
                      return kycDocument;
                    }),
                  },
                },
              },
            },
          };
        }
        return profile;
      });

      return {
        ...state,
        profiles: {
          state: profiles,
        },
      };
    })

    /**
     * Remove KYC document reducers
     */
    .handleType(ProfileKycActionTypes.REMOVE_KYC_DOCUMENT, (state, action) => {
      const profiles = state.profiles.state?.map((profile): IState<IProfile> => {
        if (profile.state?.user.state?.userId === action.document.userId) {
          if (!profile.state?.profileKYCs) return profile;

          return {
            ...profile,
            state: {
              ...profile.state,
              profileKYCs: {
                ...profile.state.profileKYCs,
                state: {
                  ...(profile.state.profileKYCs.state || ({} as IProfileKYCsState)),
                  documents: {
                    ...profile.state.profileKYCs.state?.documents,
                    remove: {
                      ...profile.state.profileKYCs.state?.documents?.remove,
                      error: undefined,
                      isLoading: true,
                    },
                  },
                },
              },
            },
          };
        }

        return profile;
      });

      return {
        ...state,
        profiles: {
          state: profiles,
        },
      };
    })

    .handleType(ProfileKycActionTypes.REMOVE_KYC_DOCUMENT_FAIL, (state, action) => {
      const profiles = state.profiles.state?.map((profile): IState<IProfile> => {
        if (profile.state?.user.state?.userId === action.document.userId) {
          if (!profile.state?.profileKYCs) return profile;

          return {
            ...profile,
            state: {
              ...profile.state,
              profileKYCs: {
                ...profile.state.profileKYCs,
                state: {
                  ...(profile.state.profileKYCs.state || ({} as IProfileKYCsState)),
                  documents: {
                    ...profile.state.profileKYCs.state?.documents,
                    remove: {
                      ...profile.state.profileKYCs.state?.documents?.remove,
                      error: action.error,
                      isLoading: false,
                    },
                  },
                },
              },
            },
          };
        }

        return profile;
      });

      return {
        ...state,
        profiles: {
          state: profiles,
        },
      };
    })

    .handleType(ProfileKycActionTypes.REMOVE_KYC_DOCUMENT_SUCCESS, (state, action) => {
      const profiles = state.profiles.state?.map((profile): IState<IProfile> => {
        if (profile.state?.user.state?.userId === action.document.userId) {
          if (!profile.state?.profileKYCs) return profile;

          return {
            ...profile,
            state: {
              ...profile.state,
              profileKYCs: {
                ...profile.state.profileKYCs,
                state: {
                  ...(profile.state.profileKYCs.state || ({} as IProfileKYCsState)),
                  documents: {
                    ...profile.state.profileKYCs.state?.documents,
                    remove: {
                      ...profile.state.profileKYCs.state?.documents?.remove, //TBC
                      isLoading: false,
                    },
                    state:
                      profile.state?.profileKYCs?.state?.documents?.state?.filter(
                        (kycDocument) => kycDocument.document.documentId !== action.document.documentId,
                      ) || [],
                  },
                },
              },
            },
          };
        }

        return profile;
      });

      return {
        ...state,
        profiles: {
          state: profiles,
        },
      };
    })

    /**
     * Add KYC document reducers
     */
    .handleType(ProfileKycActionTypes.ADD_KYC_DOCUMENT, (state, action) =>
      handleAsyncProfileReducer(
        state,
        action.userId,
        { kyc: { create: {} } },
        { state: action?.batchIndex ? { batchIndex: action?.batchIndex } : undefined },
      ),
    )

    .handleType(ProfileKycActionTypes.ADD_KYC_DOCUMENT_FAIL, (state, action) =>
      handleAsyncProfileReducer(
        state,
        action.userId,
        { kyc: { create: {} } },
        { error: action?.error, state: { batchIndex: action?.batchIndex } },
      ),
    )

    .handleType(ProfileKycActionTypes.ADD_KYC_DOCUMENT_SUCCESS, (state, action) => {
      const profiles = state.profiles.state?.map((profile): IState<IProfile> => {
        if (profile.state?.user.state?.userId === action.document.userId) {
          return {
            ...profile,
            state: {
              ...profile.state,
              profileKYCs: {
                ...profile.state.profileKYCs,
                state: {
                  ...(profile.state.profileKYCs?.state || ({} as IProfileKYCsState)),
                  documents: {
                    ...profile.state.profileKYCs?.state?.documents,
                    state: [
                      { document: { ...action.document } },
                      ...(profile.state?.profileKYCs?.state?.documents?.state || []),
                    ],
                    create: {
                      isLoading: false,
                      error: undefined,
                      state: action?.batchIndex
                        ? {
                            ...(profile.state?.profileKYCs?.state?.documents?.create?.state || {}),
                            [action.batchIndex]: {
                              isLoading: false,
                              error: undefined,
                            },
                          }
                        : undefined,
                    },
                  },
                },
              },
            },
          };
        }

        return profile;
      });

      return {
        ...state,
        profiles: {
          state: profiles,
        },
      };
    })

    /**
     * Edit KYC document reducers
     */
    .handleType(ProfileKycActionTypes.EDIT_KYC_DOCUMENT, (state, action) =>
      handleAsyncProfileReducer(state, action.document.userId, { kyc: { documentId: action.document.documentId } }),
    )

    .handleType(ProfileKycActionTypes.EDIT_KYC_DOCUMENT_FAIL, (state, action) =>
      handleAsyncProfileReducer(
        state,
        action.document.userId,
        { kyc: { documentId: action.document.documentId } },
        { error: action.error },
      ),
    )

    .handleType(ProfileKycActionTypes.EDIT_KYC_DOCUMENT_SUCCESS, (state, action) =>
      handleAsyncProfileReducer(
        state,
        action.document.userId,
        { kyc: { documentId: action.document.documentId } },
        { state: { document: action.document }, error: undefined },
      ),
    )

    /**
     * Submit KYC documents reducers
     */
    .handleType(ProfileKycActionTypes.SUBMIT_KYC, (state, action) =>
      handleAsyncProfileReducer(state, action.userId, { kyc: { submit: {} } }),
    )

    .handleType(ProfileKycActionTypes.SUBMIT_KYC_FAIL, (state, action) =>
      handleAsyncProfileReducer(state, action.userId, { kyc: { submit: {} } }, { error: action.error }),
    )

    .handleType(ProfileKycActionTypes.SUBMIT_KYC_SUCCESS, (state, action) => {
      const profiles = state.profiles.state?.map((profile): IState<IProfile> => {
        if (profile.state?.user.state?.userId === action.user.userId) {
          return {
            ...profile,
            state: {
              ...profile.state,
              user: { state: action.user },
              profileKYCs: {
                ...profile.state.profileKYCs,
                state: {
                  ...(profile.state.profileKYCs?.state || ({} as IProfileKYCsState)),
                  documents: {
                    ...profile.state.profileKYCs?.state?.documents,
                    submit: {
                      isLoading: false,
                      error: undefined,
                    },
                  },
                },
              },
            },
          };
        }

        return profile;
      });

      return {
        ...state,
        profiles: {
          state: profiles,
        },
      };
    })
    /**
     * Add Child  KYC Document
     */
    .handleType(ProfileKycActionTypes.ADD_CHILD_KYC_DOCUMENT, (state, action) => {
      return handleAsyncProfileReducer(
        state,
        action.parentId,
        { children: { items: { id: action.userId, kyc: {} } } },
        { state: action?.batchIndex ? { batchIndex: action?.batchIndex } : undefined },
      );
    })
    .handleType(ProfileKycActionTypes.ADD_CHILD_KYC_DOCUMENT_SUCCESS, (state, action) => {
      const profiles = state.profiles.state?.map((profile): IState<IProfile> => {
        if (profile.state?.user.state?.userId === action.parentId) {
          return {
            ...profile,
            state: {
              ...profile.state,
              children: {
                ...profile.state.children,
                state: profile.state.children.state?.map((childState: IState<Omit<IProfile, 'children'>>) => {
                  if (childState.state?.user.state?.userId === action.userId) {
                    return {
                      ...childState,
                      state: {
                        ...childState.state,
                        profileKYCs: {
                          ...childState.state.profileKYCs,
                          state: {
                            ...(childState.state.profileKYCs?.state || ({} as IProfileKYCsState)),
                            documents: {
                              ...childState.state.profileKYCs?.state?.documents,
                              state: [
                                { document: { ...action.document } },
                                ...(childState?.state?.profileKYCs?.state?.documents.state || []),
                              ],
                              create: {
                                isLoading: false,
                                error: undefined,
                                state: action?.batchIndex
                                  ? {
                                      ...(childState.state.profileKYCs?.state?.documents?.create?.state || {}),
                                      [action?.batchIndex]: {
                                        isLoading: false,
                                        error: undefined,
                                      },
                                    }
                                  : undefined,
                              },
                            },
                          },
                        },
                      },
                    };
                  }
                  return childState;
                }),
              },
            },
          };
        }

        return profile;
      });

      return {
        ...state,
        profiles: {
          state: profiles,
        },
      };
    })

    .handleType(ProfileKycActionTypes.ADD_CHILD_KYC_DOCUMENT_FAIL, (state, action) =>
      handleAsyncProfileReducer(
        state,
        action.parentId,
        { children: { items: { id: action.userId, kyc: {} } } },
        { error: action?.error, state: { batchIndex: action?.batchIndex } },
      ),
    );
